import React from 'react';

const AreaChartIcon = ({ size }: { size: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height="62"
      fill="none"
      viewBox="0 0 80 56"
    >
      <path
        fill="#818CF8"
        fillOpacity="0.125"
        d="m8 48 12-10 12 4 12-12 12 6 12-10 8 4v22H8z"
      ></path>
      <path stroke="#818CF8" strokeWidth="1.5" d="m8 48 12-10 12 4 12-12 12 6 12-10 8 4"></path>
      <path
        fill="#3B82F6"
        fillOpacity="0.125"
        d="m8 42 12-14 12 6 12-16 12 6 12-12 8 4v36H8z"
      ></path>
      <path stroke="#3B82F6" strokeWidth="1.5" d="m8 42 12-14 12 6 12-16 12 6 12-12 8 4"></path>
    </svg>
  );
};

export default AreaChartIcon;
